// extracted by mini-css-extract-plugin
module.exports = {"header":"Component-pepxpress_header__15DD1","info":"Component-pepxpress_info__3Ds1B"};